import { Controller } from "@hotwired/stimulus";
import getCsrfToken from "../utils/csrf";
import { useDispatch } from "stimulus-use";
import { t } from "../i18n/t";
import $ from "jquery";

export default class extends Controller {
    static targets = ["modal", "dateHint", "channelHint", "from", "to", "price", "offer", "listingList", "selectedList",
                      "addNewListingBtn", "loadMoreBtn", "submitButton", "trigger", "groupsField", "tenantsField"];
    static listingsFetchTimer;
    static validationTimer;
    static nextStepTimer;

    connect() {
        useDispatch(this);
        this.initializeListingSection();
        this.initializeControls();
        this.startValidationMonitor();
        this.toggleAvailability();

        this.boundBundleTotalsUpdated = () => this.updateAvailabilitySummaryString();
        window.addEventListener("bundles:totals-updated", this.boundBundleTotalsUpdated);
    }

    disconnect() {
        if (this.listingsFetchTimer) clearInterval(this.listingsFetchTimer);
        if (this.validationTimer) clearInterval(this.validationTimer);
        if (this.nextStepTimer) clearInterval(this.nextStepTimer);

        if (this.boundBundleTotalsUpdated) {
            window.removeEventListener("bundles:totals-updated", this.boundBundleTotalsUpdated);
        }
    }

    showElements() {
        if (this.hasOfferTarget && this.hasListingListTarget) {
            [this.offerTarget, this.listingListTarget].forEach(el => {
                el.classList.remove("is-hidden");
                el.parentElement.classList.remove("is-hidden");
            });
        }
    }

    moveSelectedToTop() {
        if (this.hasLoadMoreBtnTarget) {
            this.loadMoreBtnTarget.classList.remove('is-hidden');
        }
        if (this.hasSelectedListTarget) {
            const parent = this.selectedListTarget.parentElement;
            if (parent?.firstChild) {
                parent.insertBefore(this.selectedListTarget, parent.firstChild);
            }
        }
    }

    showAddBookingBtn() {
        if (this.hasAddNewListingBtnTarget) {
            this.addNewListingBtnTarget.classList.remove('is-hidden');
        }
    }

    initializeListingSection() {
        const listingsSearchInput = document.getElementById("bundle_listing");
        if (listingsSearchInput) {
        const channelSelection = document.getElementById("bundle_channels");
        this.listingsFetchTimer = setInterval(() => {
            const term = listingsSearchInput.getAttribute("data-term");
            const newTerm = listingsSearchInput.value;

            const channelId = listingsSearchInput.getAttribute("data-channelid");
            let newChannelId = "0";
            if (channelSelection) {
                newChannelId = channelSelection.value;
            }

            if (term !== newTerm || channelId !== newChannelId) {
                let editTrue = document.getElementById("offer_edit_form")?.value === "true";
                let addBookingsSection = document.querySelector(".add_bookings_section")
                if (channelSelection.value !== "" && !editTrue && addBookingsSection) {
                    addBookingsSection.classList.add('collapsed');
                    addBookingsSection.nextElementSibling?.classList.add('show');
                }

                const searchUrl = listingsSearchInput.getAttribute("data-url");
                const listingIdContainer = document.getElementById("bundle_listing_id");
                let listingId = listingIdContainer.value;

                listingsSearchInput.setAttribute("data-term", newTerm);
                listingsSearchInput.setAttribute("data-channelid", newChannelId);

                if (this.hasChannelHintTarget) {
                    if (newChannelId === "") {
                        $(this.channelHintTarget).show();
                    } else {
                        $(this.channelHintTarget).hide();
                    }
                }

                fetch(`${searchUrl}?term=${newTerm}&listing_id=${listingId}&channel_id=${newChannelId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": getCsrfToken(),
                    },
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.renderListingsList(data);
                    });
            }
        }, 700);
        }
    }

    initializeControls() {
        setTimeout(() => {
            const bookButtons = document.querySelectorAll(".modal__bundle .send-btn");
            if (bookButtons) {
                bookButtons.forEach((bookBtn) => {
                    bookBtn.addEventListener("click", () => {
                        this.bookBundle(bookBtn);
                    })
                });
            }
        }, 700);
    }

    startValidationMonitor() {
        const that = this;
        this.validationTimer = setInterval(() => {
            document
                .querySelectorAll(
                    "#channel_section, #description_and_settings_section, #photos_and_attachments_section, #add_listings_section, #availability_section"
                )
                .forEach((section) => {
                    that.updateSectionIndicator(section);
                });
        }, 500);
    }

    showBlock(element) {
        element.classList.remove('is-hidden')
    }

    hideBlock(element) {
        element.classList.add('is-hidden')

        const select = element.querySelector('select')
        if (select && $(select).data('select2')) {
            $(select).val(null).trigger('change')
        }
    }

    toggleAvailability() {
        if (!this.hasTriggerTarget) {
            return;
        }
        
        const value = this.triggerTarget.value

        switch (value) {
            case "0": // Everyone
                this.hideBlock(this.groupsFieldTarget)
                this.hideBlock(this.tenantsFieldTarget)
                break
            case "1": // Specific Tenant Groups
                this.showBlock(this.groupsFieldTarget)
                this.hideBlock(this.tenantsFieldTarget)
                break
            case "2": // Specific Tenants
                this.hideBlock(this.groupsFieldTarget)
                this.showBlock(this.tenantsFieldTarget)
                break
            default:
                this.hideBlock(this.groupsFieldTarget)
                this.hideBlock(this.tenantsFieldTarget)
        }
    }

    renderListingsList({ listings, meta: { current_page, per_page, total_entries } }) {
        if (this.hasListingListTarget && Number(current_page) === 1) {
            this.listingListTarget.innerHTML = "";
        }
        if (this.hasLoadMoreBtnTarget) {
            this.loadMoreBtnTarget.innerHTML = "";
        }

        listings.forEach((listing) => {
            const listingLine = this.buildListingLine(listing);
            if (this.hasListingListTarget) {
                this.listingListTarget.append(listingLine);
            }
        });

        const remainingCount = total_entries - current_page * per_page;
        if (remainingCount > 0) {
            const loadMoreButton = document.createElement("button");
            loadMoreButton.setAttribute("data-action", "bundles#loadMoreListings");
            loadMoreButton.setAttribute("data-next-page", current_page + 1);
            loadMoreButton.className =
                `bg-light-green inline-block w-full rounded py-3 text-center text-sm font-extrabold text-white`;
            loadMoreButton.innerHTML = `${this.loadMoreText} (+${remainingCount})`;

            if (this.hasLoadMoreBtnTarget) {
                this.loadMoreBtnTarget.append(loadMoreButton);
            }
        }
    }

    loadMoreListings(event) {
        event.preventDefault();
        const nextPage = event.currentTarget.getAttribute("data-next-page");

        const listingsSearchInput = document.getElementById("bundle_listing");
        const searchUrl = listingsSearchInput.getAttribute("data-url");

        const term = listingsSearchInput.getAttribute("data-term");
        const channelId = listingsSearchInput.getAttribute("data-channelid");

        const listingIdContainer = document.getElementById("bundle_listing_id");
        let listingId = listingIdContainer.value;

        fetch(`${searchUrl}?term=${term}&listing_id=${listingId}&channel_id=${channelId}&page=${nextPage}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": getCsrfToken(),
            },
        })
            .then((response) => response.json())
            .then((data) => {
                this.renderListingsList(data);
            });
    }

    buildListingLine(listing) {
        const listingLine = document.createElement("div");
        listingLine.classList.add("listing-line", "bg-white");
        listingLine.setAttribute("data-listing-id", listing.id);

        const listingInfo = document.createElement("div");
        listingInfo.classList.add("listing-info");

        const listingTitle = document.createElement("span");
        listingTitle.classList.add("listing-title");
        listingTitle.innerHTML = listing.title;
        listingInfo.append(listingTitle);

        const listingDescription = document.createElement("span");
        listingDescription.classList.add("listing-description");
        listingDescription.innerHTML = listing.description;
        listingInfo.append(listingDescription);

        const listingImage = document.createElement("div");
        listingImage.classList.add("listing-image");
        listingImage.style["display"] = "inline-block";
        if (listing.image_url) {
            listingImage.style["background"] = "url(" + listing.image_url + ")";
            listingImage.style["background-size"] = "contain";
        }

        listingLine.append(listingImage);
        listingLine.append(listingInfo);

        listingLine.addEventListener("click", () => {
            if (listingLine.classList.contains("selected")) return;

            this.selectListing(listingLine);
        });

        return listingLine;
    }

    addNewListing(event) {
        this.showElements();
        this.moveSelectedToTop();
        event.target.classList.add('is-hidden');
    }

    reindexBulkBookings() {
        const selected = document.querySelectorAll('#selected_listings .selected_listings_date')

        selected.forEach((bookingEl, newIndex) => {
            const rewriteValue = (value) => {
                if (!value) return value

                return value
                    .replace(/\[bookings_attributes\]\[\d+\]/g, `[bookings_attributes][${newIndex}]`)
                    .replace(/_(\d+)(?=_|$)/g, `_${newIndex}`)
                    .replace(/(booking|selectedlistingsdate|selectedlistingsprice|offerfrom|offerto|offerdates|offerprice|from|to)(\d+)(?=[a-z_]|$)/g, `$1${newIndex}`)
            }

            bookingEl.dataset.bookingIndex = String(newIndex)
            bookingEl.id = rewriteValue(bookingEl.id)

            bookingEl.querySelectorAll('*').forEach((el) => {
                if (el.dataset && el.dataset.bookingIndex !== undefined) {
                    el.dataset.bookingIndex = String(newIndex)
                }

                if (el.id) {
                    el.id = rewriteValue(el.id)
                }

                if (el.name) {
                    el.name = rewriteValue(el.name)
                }

                const currentFor = el.getAttribute?.('for')
                if (currentFor) {
                    el.setAttribute('for', rewriteValue(currentFor))
                }
            })
        })
    }

    selectListing(listingLine) {
        if (this.hasLoadMoreBtnTarget) {
            this.loadMoreBtnTarget.classList.add('is-hidden');
        }
        const listingRemoveBtn = document.createElement("i");
        listingRemoveBtn.classList.add("icon-trash-can");
        listingRemoveBtn.classList.add("listing-remove");
        listingRemoveBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            listingRemoveBtn.remove();
            listingLine.classList.remove("selected");
        });

        listingLine.classList.add('is-hidden');

        let selectedListings = document.getElementById("selected_listings");
        let selectedListingsList = document.getElementById("selected_listings_list");

        if (selectedListings) {
            const form = document.getElementById("bundle_form");

            const bookingIndex = document.querySelectorAll("#selected_listings .bulk-selected").length;
            let listingId = listingLine.dataset['listingId'];

            let copiedListingLine = listingLine.cloneNode(true);
            copiedListingLine.classList.add("bulk-selected");
            copiedListingLine.classList.remove("d-none");
            copiedListingLine.classList.remove("is-hidden");

            let bookingRemoveBtn = listingRemoveBtn.cloneNode(true);

            const newDateContainer = this.createFreshDateContainer(bookingIndex, listingId);
            let newPriceContainer = this.createFreshPriceContainer(bookingIndex, listingId);

            bookingRemoveBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                listingLine.classList.remove('is-hidden');
                copiedListingLine.remove();
                newDateContainer.remove();
                newPriceContainer.remove();
                this.reindexBulkBookings();
                let selectedListingsPresent = document.getElementById("selected_listings").hasChildNodes();
                if (selectedListingsPresent) {
                    this.showAddBookingBtn();
                } else {
                    this.showElements();
                    this.moveSelectedToTop();
                }
                if (document.querySelectorAll("#selected_listings .bulk-selected").length === 0) {
                    if (this.hasFromTarget) this.fromTarget.value = "";
                    if (this.hasToTarget) this.toTarget.value = "";
                    document.getElementById("selected_listings")?.classList.add("hidden");
                }
            });

            copiedListingLine.append(bookingRemoveBtn);
            copiedListingLine.classList.add("bg-white");
            selectedListingsList.classList.remove("hidden");
            selectedListings.classList.remove("hidden");
            selectedListings.appendChild(newDateContainer);
            newDateContainer.insertBefore(copiedListingLine, newDateContainer.firstChild);

            form.querySelector('.total-price__section a')?.classList.add("d-none");
        }

        if (this.hasOfferTarget && this.hasListingListTarget) {
            [this.offerTarget, this.listingListTarget].forEach(el => {
                el.classList.add("is-hidden");
                el.parentElement.classList.add("is-hidden");
            })
        }

        const selected = document.querySelectorAll('#selected_listings .selected_listings_date');
        const newIndex = 0;

        selected.forEach((bookingEl, newIndex) => {
            bookingEl.dataset.bookingIndex = String(newIndex)

            bookingEl.querySelectorAll('div').forEach(div => {
                const id = div.id;
                div.id = id.replace(/_\d+_/, `_${newIndex}_`);
            });
        })
        this.showAddBookingBtn();
    }

    createFreshDateContainer(index, listingId) {
        const container = document.createElement("div");
        container.id = `selected_listings_date_${index}`;
        container.className = "selected_listings_date";
        container.dataset.bookingIndex = index;
        container.dataset.listingId = listingId;

        document.querySelector("#bundle_listing_id").value = listingId;

        const originalDateTemplate = document.getElementById('selected_listings_date');
        if (!originalDateTemplate) return container;
        const newDateController = originalDateTemplate.querySelector('.listing-block')?.cloneNode(true);

        container.append(newDateController);

        return container;
    }

    createFreshPriceContainer(index, listingId) {
        const container = document.createElement("div");
        container.id = `selected_listings_price_${index}`;
        container.className = "pt-2";
        container.dataset.bookingIndex = index;
        container.dataset.listingId = listingId;

        const priceDiv = document.createElement("div");
        priceDiv.className = "booking-invitation__total-price";
        container.appendChild(priceDiv);

        return container;
    }

    validateMultiLanguageGroup(section, fieldName) {
        const group = Array.from(section.querySelectorAll(`[name*="${fieldName}_"]`));
        const isFilled = group.some(input => input.value.trim() !== "");

        group.forEach(input => {
            input.closest('.input__group').classList.toggle('input--error', !isFilled);
        });

        return isFilled;
    }

    validateImagesSection(section) {
        const images = Array.from(section.querySelectorAll('.template-download'));
        const isFilled = images.length > 0;

        return isFilled;
    }

    validateListingsSection(section) {
        const listings = Array.from(section.querySelectorAll('.selected_listings_date'));
        const isFilled = listings.length > 0;

        return isFilled;
    }

    updateSectionIndicator(section) {
        const validatedInputs = Array.from(section.querySelectorAll('[data-validate="true"]'));
        const titleValid = this.validateMultiLanguageGroup(section, 'title');
        const descValid = this.validateMultiLanguageGroup(section, 'description');
        const imgValid = this.validateImagesSection(section, 'photos_and_attachments');
        const listingsValid = this.validateListingsSection(section, 'add_listings_section');
        const filled = validatedInputs.every((input) => {
            return !!input.value;
        });
        const sectionHeader = document.querySelector(`.section__header[data-target="#${section.getAttribute("id")}"]`);
        if (sectionHeader) {
            if (filled || (titleValid && descValid) || imgValid || listingsValid) {
                const isStep2 = sectionHeader.classList.contains('step-2');
                let shouldClearErrors = true;

                if (isStep2) {
                    if (!!Array.from(document.querySelectorAll('[id^="offer_dates_"][id$="_error"]'))
                        .find(el => el.textContent.trim())) {
                        shouldClearErrors = false;
                    }
                    else {
                        shouldClearErrors = true;
                    }
                }

                if (shouldClearErrors) {
                    section.querySelectorAll(".modal__offer .input__error").forEach((errorHolder) => {
                        errorHolder.innerHTML = "";
                        errorHolder.classList.add("is-hidden");
                    });
                    sectionHeader.classList.remove("invalid");
                    sectionHeader.classList.add("filled");
                }
            } else {
                sectionHeader.classList.remove("filled")
            }
        }
    }

    syncTopDatesToRows() {
        if (this._isSyncing) return;

        const { topFromInput, topToInput } = this.getTopDateInputs();

        if (!topFromInput || !topToInput) return;

        const fromValue = topFromInput.value;
        const toValue = topToInput.value;
        this.notifySchedulerDateRange(fromValue, toValue, topFromInput);

        const childListingRows = this.getBookingRows();

        this._isSyncing = true;

        try {
            childListingRows.forEach((row) => {
                const index = row.dataset.bookingIndex;
                if (index === undefined) return;

                const childFromInput = this.getDateInputByBookingIndex(index, 'from');
                const childToInput = this.getDateInputByBookingIndex(index, 'to');

                let modified = false;

                if (childFromInput && childFromInput.value !== fromValue) {
                    childFromInput.value = fromValue;
                    this._updateFlatpickrValue(childFromInput, fromValue);
                    modified = true;
                }

                if (childToInput && childToInput.value !== toValue) {
                    childToInput.value = toValue;
                    this._updateFlatpickrValue(childToInput, toValue);
                    modified = true;
                }

                if (modified && childFromInput) {
                    childFromInput.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });
        } finally {
            this._isSyncing = false;
        }

        setTimeout(() => {
            this.updateAvailabilitySummaryString();
        }, 1000);
    }

    notifySchedulerDateRange(fromDate, toDate, inputElement) {
        if (!fromDate && !toDate) return;

        const dateRangeWrapper = inputElement?.closest('[data-controller~="date-range"]');
        const dateFormat = dateRangeWrapper?.dataset?.dateRangeDateFormat || null;

        window.dispatchEvent(new CustomEvent('bundles:top-date-range-changed', {
            detail: {
                fromDate,
                toDate,
                dateFormat
            }
        }));
    }

    _updateFlatpickrValue(inputElement, dateString) {
        if (!inputElement) return;

        inputElement.value = dateString || "";

        if (!dateString) {
            if (inputElement._flatpickr) inputElement._flatpickr.clear();
            return;
        }

        if (inputElement._flatpickr) {
            inputElement._flatpickr.setDate(dateString, false);
        }

        const dateRangeWrapper = inputElement.closest('[data-controller~="date-range"]');
        if (dateRangeWrapper) {
            const dateRangeController = this.application.getControllerForElementAndIdentifier(
                dateRangeWrapper,
                "date-range"
            );

            if (dateRangeController) {
                if (typeof dateRangeController.onInputManuallyChanged === "function") {
                    dateRangeController.onInputManuallyChanged();
                }

                const childFrom = dateRangeController.firstInputTarget.value;
                const childTo = dateRangeController.secondInputTarget.value;

                if (childFrom && childTo && typeof dateRangeController.checkAvailability === "function") {
                    dateRangeController.checkAvailability(childFrom, childTo);
                }
            }
        }
    }

    updateAvailabilitySummaryString() {
        const allListingRows = this.getBookingRows();
        const totalCount = allListingRows.length;

        if (totalCount === 0) return;

        let availableCount = 0;

        allListingRows.forEach((row) => {
            const index = row.dataset.bookingIndex;
            const priceHolder = document.querySelector(`.total-price-holder[data-booking-index="${index}"]`);

            if (priceHolder && priceHolder.style.display === "none") {
                return;
            }

            const priceTextElement = priceHolder?.querySelector(".total-price-amount") || row.querySelector(".total-price-amount");
            if (priceTextElement) {
                const rawText = priceTextElement.textContent.replace(/,/g, '').trim();
                const rawPrice = parseFloat(rawText) || 0;

                if (rawPrice > 0) {
                    availableCount++;
                }
            }
        });

        const targetOutputNode = document.getElementById("availability-summary-text");
        if (targetOutputNode) {
            const summaryTemplate = t("bundles.listings.availability", this.locale);
            targetOutputNode.textContent = summaryTemplate
                .replace("%{count}", String(availableCount))
                .replace("%{total}", String(totalCount));
        }
    }

    getTopDateInputs() {
        const topFromInput = this.hasFromTarget
            ? this.fromTarget
            : document.querySelector('#modal__bundle_wizard [data-offers-target="from"]');
        const topToInput = this.hasToTarget
            ? this.toTarget
            : document.querySelector('#modal__bundle_wizard [data-offers-target="to"]');

        return { topFromInput, topToInput };
    }

    getBookingRows() {
        return document.querySelectorAll('#modal__bundle_wizard .selected_listings_date[data-booking-index]');
    }

    getDateInputByBookingIndex(index, field) {
        const row = document.querySelector(`#modal__bundle_wizard .selected_listings_date[data-booking-index="${index}"]`);
        if (!row) return null;

        if (field === 'from') {
            return row.querySelector('[data-date-range-target="firstInput"]') || document.getElementById(`booking_${index}_from`);
        }

        return row.querySelector('[data-date-range-target="secondInput"]') || document.getElementById(`booking_${index}_to`);
    }

    bookBundle(bookBtn) {
        bookBtn.disabled = true;

        let bookBundle = document.getElementById("modal__bundle_wizard")?.checkVisibility();

        const form = document.getElementById("bundle_form")
        const method = form.getAttribute("data-method");
        const action = form.getAttribute("data-action");
        const userId = document.querySelector("#bundle_user_id")?.value;
        const bundleId = document.querySelector("#bundle_id")?.value;
        const dateType = document.querySelector("[name='bundle[date_type]']:checked")?.value || "";
        const bundleListings = document.querySelectorAll('.selected_listings_date');
        const bulkSelectedListings = Array.from(document.querySelectorAll(".total-price-holder[data-listing-id] .total-price-amount"))
            .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)
            .map(visibleAmountEl => {
                return visibleAmountEl.closest(".total-price-holder");
            });
        const bundleAvailableFor = document.querySelector('#bundle_bundle_available_for')?.value || "";
        const bundleListingIds = Array.from(bundleListings).map(el => el.dataset.listingId);
        const listingIds = Array.from(bulkSelectedListings).map(el => el.dataset.listingId);
        const bundleTitleEn = document.querySelector("#bundle_title_en")?.value || "";
        const bundleTitleDe = document.querySelector("#bundle_title_de")?.value || "";
        const bundleTitleFr = document.querySelector("#bundle_title_fr")?.value || "";
        const bundleTitleIt = document.querySelector("#bundle_title_it")?.value || "";
        const bundleTitleHu = document.querySelector("#bundle_title_hu")?.value || "";
        const bundleDescriptionEn = document.querySelector("#bundle_description_en")?.value || "";
        const bundleDescriptionDe = document.querySelector("#bundle_description_de")?.value || "";
        const bundleDescriptionFr = document.querySelector("#bundle_description_fr")?.value || "";
        const bundleDescriptionIt = document.querySelector("#bundle_description_it")?.value || "";
        const bundleDescriptionHu = document.querySelector("#bundle_description_hu")?.value || "";
        const isDraft = document.querySelector("[name='bundle[is_draft]']")?.value || "";
        const isActive = document.querySelector("[name='bundle[is_active]']:checked")?.value || "";
        const attachments = Array.from(document.querySelectorAll('input[name="booking[landlord_attachment_ids][]"]')).map(
            (input) => input.value
        );
        const bundleTotalAmount = document.querySelector("#bundle_total_amount")?.value || "0";
        const bundleDiscountAmount = document.querySelector("#bundle_discount_amount")?.value || "0";
        const bundleDiscountedTotalAmount = document.querySelector("#bundle_discounted_total_amount")?.value || "0";

        let channelIds = [];
        const channelInput = document.querySelector("#bundle_channels");
        if (channelInput) {
            channelIds = Array.from(channelInput.selectedOptions).map(opt => opt.value);
        }

        if (bookBundle) {
            let bookingDataArray = Array.from(bulkSelectedListings).map((bookingEl) => {
                let bookingIndex = bookingEl?.dataset?.bookingIndex;
                let listingId = bookingEl.getAttribute("data-listing-id");
                let fromInput = document.getElementById(`booking_${bookingIndex}_from`);
                let toInput = document.getElementById(`booking_${bookingIndex}_to`);

                return {
                    user_id: userId,
                    listing_id: listingId,
                    from: fromInput?.value,
                    to: toInput?.value,
                    ...(attachments.length > 0 && { landlord_attachment_ids: attachments }),
                };
            });

            $.ajax({
                url: action,
                type: method,
                data: {
                    bundle: {
                        bundle_no: bundleId,
                        user_id: userId,
                        listing_ids: listingIds,
                        total_amount: bundleTotalAmount,
                        discount_amount: bundleDiscountAmount,
                        discounted_total_amount: bundleDiscountedTotalAmount,
                        bulk_bookings: bookingDataArray
                    },
                },
            })
                .done((data) => {
                    this.submitButtonTarget.disabled = false;
                    if (data.errors) {
                        this.showErrorNotifications(data.errors);
                    } else {
                        window.location.reload();
                    }
                })
                .fail(() => {
                    this.submitButtonTarget.disabled = false;
                    $(this.modalTarget).modal("hide");
                });
        } else {
            const selectedTenantGroupIds = document.querySelector('#bundle_tenant_group_ids');
            const tenantGroupIds = Array.from(selectedTenantGroupIds.selectedOptions).map(option => option.value);
            const selectedTenantsIds = document.querySelector('#bundle_tenants_ids');
            const tenantsIds = Array.from(selectedTenantsIds.selectedOptions).map(option => option.value);

            $.ajax({
                url: action,
                type: method,
                data: {
                    bundle: {
                        title_en: bundleTitleEn,
                        title_de: bundleTitleDe,
                        title_fr: bundleTitleFr,
                        title_it: bundleTitleIt,
                        title_hu: bundleTitleHu,
                        description_en: bundleDescriptionEn,
                        description_de: bundleDescriptionDe,
                        description_fr: bundleDescriptionFr,
                        description_it: bundleDescriptionIt,
                        description_hu: bundleDescriptionHu,
                        is_draft: isDraft,
                        is_active: isActive,
                        date_type: dateType,
                        bundle_available_for: bundleAvailableFor,
                        listing_ids: bundleListingIds,
                        tenant_group_ids: tenantGroupIds,
                        tenant_ids: tenantsIds,
                        channel_ids: channelIds
                    },
                },
            })
                .done((data) => {
                    bookBtn.disabled = false;
                    if (data.errors) {
                        this.showErrorNotifications(data.errors);
                    } else {
                        window.location.reload();
                    }
                })
                .fail(() => {
                    bookBtn.disabled = false;
                    $(this.modalTarget).modal("hide");
                });
        }
    }
    

    showErrorNotifications(errors) {
        document.querySelectorAll(".modal__offer .input__error").forEach((errorHolder) => {
            errorHolder.innerHTML = "";
            errorHolder.classList.add("is-hidden");
        });

        document.querySelectorAll(".modal__offer .accordion-section").forEach((section) => {
            section.classList.remove("invalid");
        });

        Object.entries(errors).forEach((error) => {
            let fieldName = error[0];
            const errorMessage = error[1];

            if (fieldName === "dates") {
                document.querySelector("#offer_from").value = null;
                document.querySelector("#offer_to").value = null;
            }

            const errorHolder = document.getElementById(`offer_${fieldName}_error`);
            if (errorHolder) {
                const sectionName = errorHolder.getAttribute("data-section");
                if (!sectionName) return;
                requestAnimationFrame(() => {
                    const section = document.querySelector(`.accordion-section.${sectionName}`);

                    if (section) {
                        section.classList.add("invalid");
                    }
                    errorHolder.classList.remove("is-hidden");
                    errorHolder.innerHTML = Array.isArray(errorMessage) ? errorMessage[0] : errorMessage;
                });
            }
        });
    }

    get loadMoreText() {
        return this.data.get("loadMoreText") || "Load more";
    }

    get locale() {
        return this.data.get("locale") || "en";
    }

    get modalType() {
        return this.data.get("modalType");
    }
}
